// Toaster removed - using global Toaster from App.js
import { useNavigate } from 'react-router-dom';

/**
 * Loading state component
 */
export const LoadingState = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-500 dark:border-emerald-400 mx-auto mb-4"></div>
        <p className="text-gray-600 dark:text-gray-400">Loading live session...</p>
      </div>
    </div>
  );
};

/**
 * Error state component
 */
export const ErrorState = ({ error, isConsultant }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      {/* Toaster removed - using global Toaster from App.js */}
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 text-center border dark:border-gray-700">
        <div className="text-red-500 dark:text-red-400 mb-4">
          <svg className="mx-auto h-12 w-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Session Not Found</h2>
        <p className="text-gray-600 dark:text-gray-400 mb-4">{error}</p>
        <button
          onClick={() => navigate(isConsultant ? '/consultant/dashboard' : '/dashboard')}
          className="px-4 py-2 bg-emerald-600 dark:bg-emerald-500 text-white rounded-md hover:bg-emerald-700 dark:hover:bg-emerald-600"
        >
          Back to {isConsultant ? 'Clients' : 'Dashboard'}
        </button>
      </div>
    </div>
  );
};

